package io.eqoty.shared.datalayer

import io.eqoty.shared.datalayer.sources.web3.JsKeplrWeb3Provider
import io.eqoty.shared.datalayer.sources.web3.JsWeb3Provider

val Repository.jsWeb3Provider: JsWeb3Provider get() = web3Provider as JsWeb3Provider
val Repository.jsKeplrWeb3Provider: JsKeplrWeb3Provider get() = web3Provider as JsKeplrWeb3Provider